import {useCallback,useEffect,useRef,useState} from 'react';
import {publicCatalog} from '../lib/assessmentApi';
import {publishedAssessments} from '../lib/publishedCatalog.mjs';

const REFRESH_MS=30000;
export const ASSESSMENT_CATALOG_CHANNEL='bpa-assessment-catalog-v1';

// A single source of truth: the Gateway's enabled, published definitions.
// Refresh on visibility/focus and periodically while the library is open.
export function usePublishedAssessments(){
  const [published,setPublished]=useState([]);
  const [warning,setWarning]=useState('');
  const [loading,setLoading]=useState(true);
  const pending=useRef(0);
  const refresh=useCallback(async()=>{
    const request=++pending.current;
    try{
      const result=publishedAssessments(await publicCatalog());
      if(request!==pending.current)return;
      setPublished(result);setWarning('');
    }catch(error){
      if(request!==pending.current)return;
      const detail=error?.message||'The catalog could not be loaded.';
      setWarning('Published assessments could not be refreshed. '+detail);
    }finally{
      if(request===pending.current)setLoading(false);
    }
  },[]);
  useEffect(()=>{
    const focused=()=>{if(!document.hidden)refresh();};
    const channel=typeof BroadcastChannel!=='undefined'
      ?new BroadcastChannel(ASSESSMENT_CATALOG_CHANNEL):null;
    if(channel)channel.onmessage=e=>{if(e.data?.type==='catalog-updated')refresh();};
    window.addEventListener('focus',focused);
    document.addEventListener('visibilitychange',focused);
    const timer=window.setInterval(focused,REFRESH_MS);
    refresh();
    return ()=>{
      pending.current++;
      window.removeEventListener('focus',focused);
      document.removeEventListener('visibilitychange',focused);
      window.clearInterval(timer);
      channel?.close();
    };
  },[refresh]);
  return {published,warning,loading,refresh};
}
export function notifyAssessmentCatalogUpdated(){
  if(typeof BroadcastChannel==='undefined')return;
  const channel=new BroadcastChannel(ASSESSMENT_CATALOG_CHANNEL);
  channel.postMessage({type:'catalog-updated'});
  channel.close();
}